import { useCallback, useEffect, useState } from 'react';
import { getUsers, deleteUser } from 'api';

export const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      setUsers(await getUsers());
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const removeUser = useCallback(async (userId) => {
    try {
      await deleteUser(userId);
      await refresh();
    } catch (e) {
      setError(e.message);
    }
  }, [refresh]);

  return { users, loading, error, refresh, removeUser };
};
